import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';

const RoutesFormatter = ({ routes }) => (
  <Grid container spacing={1}>
    {routes.map(route => (
      <Grid item key={route?.origin?.uri}>
        <Chip label={route?.origin?.uri} />
      </Grid>
    ))}
  </Grid>
);

RoutesFormatter.propTypes = {
  routes: PropTypes.array,
};

RoutesFormatter.defaultProps = {
  routes: [],
};

export default RoutesFormatter;
